import React from 'react';

import '../css/BlueButton.scss';

export default function BlueButton({content, type, action}) {
    return (
        <button className='blueButton' onClick={() => action()}>{content}</button>
    )
}